export default __webpack_public_path__ + "static/polio-8160e28125ba0112722d4aa80b84c9cb.png";